var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgUncheck = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M1.50001 2.75003C1.50001 2.05967 2.05965 1.50003 2.75001 1.50003H19.75C20.4404 1.50003 21 2.05967 21 2.75003L21 19.75C21 20.4404 20.4404 21 19.75 21H2.75C2.05964 21 1.5 20.4404 1.5 19.75L1.50001 2.75003ZM2.75001 3.05176e-05C1.23123 3.05176e-05 8.58307e-06 1.23125 8.58307e-06 2.75003L0 19.75C0 21.2688 1.23122 22.5 2.75 22.5H19.75C21.2688 22.5 22.5 21.2688 22.5 19.75L22.5 2.75003C22.5 1.23125 21.2688 3.05176e-05 19.75 3.05176e-05H2.75001ZM6.75 10.5C6.33579 10.5 6 10.8358 6 11.25C6 11.6642 6.33579 12 6.75 12H15.75C16.1642 12 16.5 11.6642 16.5 11.25C16.5 10.8358 16.1642 10.5 15.75 10.5H6.75Z"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgUncheck);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/uncheck.7cb776c6ed007b1b735e6b93893ddb56.svg";